import React from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetTrigger } from '@/components/ui/sheet';
import { ScrollArea } from '@/components/ui/scroll-area';
import { HelpCircle, BookOpen } from 'lucide-react';
import { HOTEL_GUIDES } from '@/lib/hotelGuides';

// Pulsante "?" presente in ogni pagina Hotel: apre un pannello con la guida della pagina.
export const HelpButton = ({ pageKey }) => {
  const guide = HOTEL_GUIDES[pageKey];
  if (!guide) return null;
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Apri la guida della pagina"
          title="Guida di questa pagina" data-testid="help-button">
          <HelpCircle className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full max-w-md p-0" data-testid="help-panel">
        <SheetHeader className="border-b border-border px-5 py-4">
          <SheetTitle className="flex items-center gap-2">
            <BookOpen className="h-5 w-5 text-primary" />
            Guida · {guide.title}
          </SheetTitle>
          <SheetDescription className="text-left">{guide.intro}</SheetDescription>
        </SheetHeader>
        <ScrollArea className="h-[calc(100vh-88px)] px-5 py-4">
          <div className="space-y-4">
            {guide.sections.map((s, i) => (
              <div key={i} className="rounded-lg border border-border bg-muted/30 p-3" data-testid={`help-section-${i}`}>
                <p className="mb-1 text-sm font-semibold text-foreground">{s.h}</p>
                <p className="text-sm leading-relaxed text-muted-foreground">{s.p}</p>
              </div>
            ))}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};
